import React from "react"
import {observer} from "mobx-react"

import DataStore from "../../../../modules/ambulance/stores/DataStore"
// import SearchDropdownNoForm from "../../../../global/ui/xsSearchdropdown/xsSearchdropdownNoForm"
import {FormattedMessage} from "react-intl"
import SearchDropdownCache from "../../../../global/ui/xsSearchdropdown/xsSearchdropdownCache"
import RegistersCacheStore from "../../../../global/store/RegistersCacheStore"

export default observer(() => {
	const selectedDiagnosisIds =
		isSafe(DataStore.patientsFilteredDiagnoses) &&
		isSafe(DataStore.patientsFilteredDiagnoses.diagnoses) &&
		DataStore.patientsFilteredDiagnoses.diagnoses.length > 0
			? DataStore.patientsFilteredDiagnoses.diagnoses.map((x) => x.id_value)
			: []

	//#region old
	// const diagnosesFilterValues = isSafe(DataStore.patientsDiagnoses)
	// 	? DataStore.patientsDiagnoses.map((dg) => {
	// 			return {
	// 				id: dg.id_value,
	// 				search_string: dg.search_string,
	// 				primaryText: dg.text_value
	// 					.split(" ")
	// 					.slice(1)
	// 					.join(" "),
	// 				secondaryText: dg.text_value.split(" ")[0],
	// 				checkValue: isSafe(diagnosesCheckedIds) && diagnosesCheckedIds.includes(dg.id_value)
	// 			}
	// 	  })
	// 		: []
	//#endregion

	return (
		<SearchDropdownCache
			selectedItems={selectedDiagnosisIds}
			sourceItems={RegistersCacheStore.diagnosisRegister}
			multiSelect={true}
			id="patientListContainer_diagnoses"
			label={<FormattedMessage id="Common.label.diagnosis" />}
			onClose={(ids) => {
				if (ids.length == 0) {
					DataStore.patientsFilteredDiagnoses = {diagnoses: null}
					DataStore.diagnoses_patientListFilter = null
				} else {
					const filteredDiagnoses =
						isSafe(DataStore.patientsFilteredDiagnoses) && isSafe(DataStore.patientsFilteredDiagnoses.diagnoses)
							? DataStore.patientsFilteredDiagnoses.diagnoses
							: []

					if (
						filteredDiagnoses.length != ids.length ||
						filteredDiagnoses.every((x) => ids.includes(x.id_value)) == false
					) {
						const filters = {
							diagnoses: ids.map((x) => {
								return {id_value: x}
							})
						}

						DataStore.patientsFilteredDiagnoses = filters
						DataStore.diagnoses_patientListFilter = filters.diagnoses
					}
				}
			}}
		/>

		//#region old

		// <SearchDropdownNoForm
		// 	items={diagnosesFilterValues}
		// 	multiSelect={true}
		// 	id="patientListContainer_diagnoses"
		// 	label={<FormattedMessage id="Common.label.diagnosis" />}
		// 	onClose={(data) => {
		// 		const selectedIds = data.map((x) => x.id)
		// 		const filteredDiagnoses =
		// 			isSafe(DataStore.patientsFilteredDiagnoses) && isSafe(DataStore.patientsFilteredDiagnoses.diagnoses)
		// 				? DataStore.patientsFilteredDiagnoses.diagnoses
		// 				: []

		// 		if (
		// 			filteredDiagnoses.length != selectedIds.length ||
		// 			filteredDiagnoses.every((x) => selectedIds.includes(x.id_value)) == false
		// 		) {
		// 			const filters = {
		// 				diagnoses:
		// 					data.length > 0
		// 						? data.map((x) => {
		// 								return {id_value: x.id}
		// 						  })
		// 						: null
		// 			}

		// 			const postObj = data.length > 0 ? filters.diagnoses : null

		// 			// const postObj = data.length > 0 ?
		// 			//   {
		// 			//     filters: [{
		// 			//       associated_column: "diagnoses",
		// 			//       values: filters.diagnoses
		// 			//     }]
		// 			//   }
		// 			//   : null

		// 			DataStore.patientsFilteredDiagnoses = filters
		// 			DataStore.diagnoses_patientListFilter = postObj
		// 		}
		// 	}}
		// />

		//#endregion
	)
})
